import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

function SubmitButton(props) {
  const { loading, label = "Submit" } = props;
  return loading ? (
    <LoadingButton
      loading
      loadingPosition="start"
      startIcon={<SaveIcon />}
      variant="outlined"
    >
      {label}
    </LoadingButton>
  ) : (
    <Button type="submit" variant="contained" color="primary">
      {label}
    </Button>
  );
}

export default SubmitButton;
